import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import Utils from '@iv/shared/utils';

@Component({
  selector: 'iv-live-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnDestroy {

  @Input() showDropdown = false;
  @Input() hasMultipleChoice = false;
  @Input() valueAttribute: string;
  @Input() label = '';
  @Input() cssClass = '';
  @Input() type = '';
  @Input() tip: any;
  @Input() addPercentSuffix = false
  @Input() dropdownOffset: { [value: string]: string } | null = null;

  @Output() selectedDataChange = new EventEmitter<any>();
  @Output() openDropdown = new EventEmitter<any>();
  @Output() closeOtherDropdown = new EventEmitter<any>();

  public isMac = Utils.isMac;

  private offClickHandler;
  private positiveIntegerRegexp = /^\d+$/;

  constructor(protected _eref: ElementRef) {
    const me = this;
    this.offClickHandler = (function () {
      const handler = function (event) {
        if (!me._eref.nativeElement.contains(event.target)) {
          me.showDropdown = false;
          if (me.type === 'ivx') {
            me.openDropdown.emit(me.showDropdown);
          }
          if (me.type === 'strike' && me._eref.nativeElement.getElementsByTagName('INPUT')[0].value === '') {
            me._eref.nativeElement.getElementsByTagName('INPUT')[0].value = me.selectedData;
          }
        }
        document.removeEventListener('click', handler, true);
      };
      return handler;
    })();
  }

  private _data: any[] = [];

  get data(): any[] {
    return this._data;
  }

  @Input() set data(value: any[]) {
    this._data = value;
  }

  private _selectedData: any;

  get selectedData(): any {
    return this._selectedData;
  }

  @Input() set selectedData(value: any) {
    this._selectedData = value;
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.offClickHandler);
  }

  getValue(selectedData): string {
    if (!selectedData || (Array.isArray(selectedData) && !selectedData.length)) {
      return '';
    }
    if (Array.isArray(selectedData)) {
      if (selectedData.length === 1) {
        return selectedData[0].value;
      }
      return `${selectedData.length} items`;
    }
    if (typeof selectedData === 'object') {
      if (selectedData[this.valueAttribute]) {
        return String(selectedData[this.valueAttribute]);
      }
      return '';
    }
    return String(selectedData);
  }

  toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();
    const nativeElement = this._eref.nativeElement;
    this.showDropdown = !this.showDropdown;
    if (this.showDropdown === true) {
      this.closeOtherDropdown.emit();
    }
    this.toggleEventListener(this.showDropdown);
    if (this.showDropdown === true && this.type === 'strike') {
      nativeElement.getElementsByTagName('INPUT')[0].value = '';
      nativeElement.getElementsByTagName('INPUT')[0].focus();
    }
    if (this.type === 'ivx') {
      this.openDropdown.emit(this.showDropdown);
    }
    this.setDropdownPosition(event, nativeElement);
  }

  setDropdownPosition(event, element) {
    const height = document.documentElement.clientHeight - event.clientY;
    if (height < 300) {
      element.classList.add('up');
    } else {
      element.classList.remove('up');
    }
  }

  onItemClick(event, item) {
    event.preventDefault();
    event.stopPropagation();
    this.updateSelectedData(item);
    this.selectedDataChange.emit(this.selectedData);
    if (!this.hasMultipleChoice) {
      this.showDropdown = false;
      if (this.type === 'ivx') {
        this.openDropdown.emit(this.showDropdown);
      }
    }
  }

  updateSelectedData(item) {
    if (!this.hasMultipleChoice || (this.type === 'expirations' && item.type === 'type')) {
      this.selectedData = item;
    } else if (Array.isArray(this.selectedData)) {
      const index = this.selectedData.findIndex(data => {
        if (this.valueAttribute) {
          return data[this.valueAttribute] === item[this.valueAttribute];
        } else {
          return data === item;
        }
      });
      if (index === -1) {
        this.selectedData.push(item);
      } else {
        this.selectedData.splice(index, 1);
      }
    } else {
      if (this.type === 'expirations'
        && this.selectedData.type === 'type'
        && item.type === 'expiration') {
        this.selectedData = item;
      } else {
        this.selectedData = [this.selectedData, item];
      }
    }
  }

  inputValue($event) {
    const newValue = $event.target.value;
    if (newValue !== '' && !this.positiveIntegerRegexp.test(newValue)) {
      $event.target.value = this.selectedData;
    }
  }

  changeValue($event) {
    const newValue = $event.target.value;
    if (newValue === '' || !this.positiveIntegerRegexp.test(newValue)) {
      $event.target.value = this.selectedData;
    } else {
      this.selectedData = newValue;
    }
    this.selectedDataChange.emit(this.selectedData);
  }

  valueHasItem(item) {
    if (Array.isArray(this.selectedData)) {
      return this.selectedData.some(data => {
        if (this.valueAttribute) {
          return data[this.valueAttribute] === item[this.valueAttribute];
        } else {
          return data === item;
        }
      });
    } else {
      if (this.valueAttribute) {
        return (this.selectedData && (this.selectedData[this.valueAttribute] === item[this.valueAttribute]));
      } else {
        return this.selectedData === item;
      }
    }
  }

  getHeight() {
    if (this.type === 'expirations') {
      return '200px';
    } else {
      return '100%';
    }
  }

  close() {
    this.showDropdown = false;
  }

  private toggleEventListener(showDropdown: boolean) {
    if (showDropdown) {
      document.addEventListener('click', this.offClickHandler);
    } else {
      document.removeEventListener('click', this.offClickHandler);
    }
  }

}
